import { render, staticRenderFns } from "./Testimonial.vue?vue&type=template&id=609f8902&scoped=true&"
import script from "./Testimonial.vue?vue&type=script&lang=js&"
export * from "./Testimonial.vue?vue&type=script&lang=js&"
import style0 from "./Testimonial.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Testimonial.vue?vue&type=style&index=1&id=609f8902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609f8902",
  null
  
)

export default component.exports